import { PlayIcon } from "@public/pages/shared/components/Attachments/icons";
import styled from "styled-components";

export const Play = styled(PlayIcon)`
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
`;

export const VideoContainer = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;

  video {
    object-fit: cover;
    border-radius: 1rem;
  }
`;

export const PlayerWrapper = styled.div`
  video {
    object-fit: contain;
    outline: none;
    cursor: pointer;
  }

  > div {
    display: flex;
    justify-content: center;
    border-radius: 2rem;
  }
`;
